export default __webpack_public_path__ + "static/media/january-min.509bf346.jpg";